import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import classNames from "classnames";
import React from "react";
import { MuiBox } from "../../box/MuiBox";
import { MuiTypography } from "../../typography/MuiTypography";
import { ASC, Column } from "../MuiTable";
import { SortIcon } from "./sortIcon/SortIcon";

interface TableHeaderProps {
  columns: Column[];
  sortColumn: string | null;
  sortDirection: string;
  isLastColumnSticky?: boolean;
  handleSort: (
    id: string,
    objectKeyName?: string,
    isEmptyValue?: boolean,
    sortKeyName?: string,
    considerSortAsString?: boolean,
  ) => void;
  commonARIALabel: {
    column: string;
    sortAscending: string;
    sortDescending: string;
    noneSorted: string;
  };
  tableHeaderForm: React.ReactNode[];
}

const MuiTableHeader: React.FC<TableHeaderProps> = ({
  columns,
  sortColumn,
  sortDirection,
  isLastColumnSticky,
  handleSort,
  commonARIALabel,
  tableHeaderForm,
}) => (
  <TableHead>
    <TableRow key="header">
      {columns.map((column, index) => {
        const isLastColumn = columns.length === index + 1;
        let ariaSortLabel;
        if (sortColumn === column.id) {
          ariaSortLabel =
            sortDirection === ASC
              ? commonARIALabel.sortAscending
              : commonARIALabel.sortDescending;
        } else {
          ariaSortLabel = commonARIALabel.noneSorted;
        }

        return (
          <TableCell
            role={column.headerRender ? "none" : "button"}
            key={column.id}
            align={column?.align}
            style={{ minWidth: column.minWidth }}
            colSpan={column.colSpan}
            className={classNames("tableHeader", column.className, {
              "sort-enabled": sortColumn === column.id,
              "pinned-right": isLastColumn && isLastColumnSticky,
            })}
            onClick={() =>
              column.isSortVisible &&
              handleSort(
                column.id,
                column.objectKeyName,
                column.isEmptyValue,
                column.sortKeyName,
                column.considerSortAsString,
              )
            }
            aria-label={`${commonARIALabel.column} ${index + 1} ${column.label} ${ariaSortLabel}`}
            tabIndex={0}
          >
            {column.headerRender ? (
              column.headerRender()
            ) : (
              <MuiBox className="custom-header">
                <MuiTypography className="tableHeader">
                  {column.label}
                </MuiTypography>
                {column.isSortVisible && (
                  <SortIcon
                    sortColumn={sortColumn}
                    column={column.id}
                    sortDirection={sortDirection}
                  />
                )}
              </MuiBox>
            )}
          </TableCell>
        );
      })}
    </TableRow>
    <TableRow className="no-background" key="tableHeaderForm">
      {tableHeaderForm.map((element, index) => {
        const isLastColumn = tableHeaderForm.length === index + 1;
        return (
          <TableCell
            className={isLastColumn && isLastColumnSticky ? "pinned-right" : ""}
            key={`${(element as any)?.props?.id ?? (element as any)?.key ?? index}-cell`}
          >
            {element}
          </TableCell>
        );
      })}
    </TableRow>
  </TableHead>
);

export default MuiTableHeader;
